import {
  EDIT_BOOK,
  SHOW_ALL_BOOKS,
  SHOW_FEATURED_BOOKS,
  UPDATE_EDIT_INFO,
  UPDATE_SEARCH_TEXT
} from './actionTypes';

export const showFeaturedBooks = () => ({
  type: SHOW_FEATURED_BOOKS,
  payload: true,
});
export const showAllBooks = () => ({
  type: SHOW_ALL_BOOKS,
  payload: false,
});
export const editBook = editInfo => ({
  type: EDIT_BOOK,
  payload: {
    editMode: true,
    editInfo,
  },
});
export const updateEditInfo = () => ({
  type: UPDATE_EDIT_INFO,
  payload: {
    editMode: false,
    editInfo: {
      id: null,
      name: '',
      author: '',
      thumbnail: '',
      price: '',
      rating: '',
      featured: false,
    },
  },
});
export const updateSearchText = text => ({
  type: UPDATE_SEARCH_TEXT,
  payload: text,
});
